import type { GeneralFormValues } from '../../../../common';

export const GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH = 4;
export const GENERAL_FORM_MINIMUM_TEXT_LENGTH = 2;
export const GENERAL_FORM_ZIP_CODE_LENGTH = 5;

export const GENERAL_INFO_FIELD_NAMES = [
  'provider_full_name',
  'provider_email',
  'primary_language',
  'relationship_to_client',
  'client_first_name',
  'client_middle_name',
  'client_last_name',
  'client_date_of_birth',
  'client_sex',
  'client_address_same_as_provider',
  'client_street_address_line_one',
  'client_street_address_line_two',
  'client_street_address_zip',
  'client_street_address_city',
  'client_street_address_state',
] as const;

export const GENERAL_INITIAL_VALUES: GeneralFormValues = {
  provider_full_name: '',
  provider_email: '',
  primary_language: '',
  relationship_to_client: '',
  client_first_name: '',
  client_middle_name: '',
  client_last_name: '',
  client_date_of_birth: null,
  client_sex: '',
  client_address_same_as_provider: false,
  client_street_address_line_one: '',
  client_street_address_line_two: '',
  client_street_address_zip: '',
  client_street_address_city: '',
  client_street_address_state: '',
};

export const RELATIONSHIP_TO_CLIENT_OPTIONS = [
  { value: 'Parent (Mother / Father)', label: 'Parent (Mother / Father)' },
  { value: 'Stepparent', label: 'Stepparent' },
  { value: 'Grandparent', label: 'Grandparent' },
  { value: 'Aunt / Uncle', label: 'Aunt / Uncle' },
  { value: 'Older sibling', label: 'Older sibling' },
  { value: 'Cousin', label: 'Cousin' },
  { value: 'Legal guardian (court-appointed)', label: 'Legal guardian (court-appointed)' },
  { value: 'Adoptive parent', label: 'Adoptive parent' },
  { value: 'Foster parent', label: 'Foster parent' },
  { value: 'Kinship caregiver (relative/friend)', label: 'Kinship caregiver (relative/friend)' },
] as const;
